<template>
  <div class="all" v-loading="loading" element-loading-text="加载中,请稍后...">
    <div class="body">
      <div class="body-main">
        <el-row>
          <el-card class="box-card">
            <el-carousel
              v-if="content.length > 0"
              indicator-position="outside"
              :arrow="content.length <= 1 ? 'never' : 'always'"
              :autoplay="false"
            >
              <el-carousel-item v-for="(item, index) in content" :key="index">
                <el-col :span="1"> </el-col>
                <el-col :span="10">
                  <div class="box-body-left">
                    <p style="margin-bottom:20px">
                      考生信息
                    </p>
                    <el-input
                      v-model="item.user_name"
                      style="width:190px"
                      :disabled="true"
                    >
                      <i slot="prefix">考生姓名 :</i>
                    </el-input>
                    <el-input
                      v-model="item.user_phone"
                      style="width:240px"
                      :disabled="true"
                    >
                      <i slot="prefix">手机号码 :</i>
                    </el-input>
                    <el-input
                      v-model="item.user_idcard"
                      style="width:450px"
                      :disabled="true"
                    >
                      <i slot="prefix">身份证号 :</i>
                    </el-input>

                    <el-button
                      v-if="item.check == 1"
                      class="login"
                      @click="totext(item)"
                      >开始考试</el-button
                    >
                    <el-button v-else class="unfinish" :disabled="true">{{
                      item.msg
                    }}</el-button>
                  </div>
                  <br />
                  <div class="footer-tip">
                    注意 : 考生信息来源于实名注册 ,
                    请确认考生信息与考试信息无误后再点击开始考试 ,
                    考试途中不得退出。
                  </div>
                </el-col>
                <el-col :span="2" align="center">
                  <el-divider direction="vertical" class="divider"></el-divider>
                </el-col>
                <el-col :span="10">
                  <div class="box-body-right">
                    <p style="margin-bottom:20px">
                      考试信息
                    </p>
                    <!-- <el-input v-model="text.sub" style="width:215px">
                            <i slot="prefix" style="padding-left:-20px">科目 :</i>
                         </el-input> -->
                    <input
                      type="text"
                      class="input"
                      v-model="item.title"
                      :disabled="true"
                    />
                    <el-input
                      v-model="item.num"
                      style="width:215px"
                      :disabled="true"
                    >
                      <i slot="prefix">试题数量 :</i>
                      <i slot="suffix">题</i>
                    </el-input>
                    <el-input
                      v-model="item.score"
                      style="width:215px"
                      :disabled="true"
                    >
                      <i slot="prefix">试卷满分 :</i>
                      <i slot="suffix">分</i>
                    </el-input>
                    <el-input
                      v-model="item.minutes"
                      style="width:215px"
                      :disabled="true"
                    >
                      <i slot="prefix">答题时间 :</i>
                      <i slot="suffix">分钟</i>
                    </el-input>
                    <el-button type="primary" class="out" @click="out"
                      >离开考试</el-button
                    >
                    <span class="text-title">科目 :</span>
                  </div>
                </el-col>
                <el-col :span="1"> </el-col>
              </el-carousel-item>
            </el-carousel>
            <div v-else style="text-aglin:center;width:100%">
              <p><i class="el-icon-warning"></i> {{ prompt }}</p>
            </div>
          </el-card>
        </el-row>
      </div>
    </div>

    <!-- <examfooter></examfooter> -->
  </div>
</template>

<script>
import examfooter from '../../components/examfooter.vue'
export default {
  components: { examfooter },
  name: 'examVerify',
  data() {
    return {
      user: {},
      state: true,
      text: {},
      title: '',
      loading: false,
      code: '',
      list: [1, 2, 3, 4],
      content: [],
      prompt: '',
    }
  },
  created() {
    let _this = this
    _this.getList()
  },
  methods: {
    getList() {
      let _this = this
      _this.loading = true
      _this.$http
        .get(process.env.VUE_APP_URL + 'showPaperList')
        .then(data => {
          _this.loading = false
          if (data.data.code == 200) {
            _this.content = data.data.data
            console.log(data.data.data)
            _this.content.sort((a, b) => b.check - a.check)
          } else {
            _this.prompt = data.data.msg
          }
        })
        .catch(err => {
          _this.loading = false
          _this.$message.error('网络错误，请重试')
          console.log(err)
        })
    },
    getExam() {
      let _this = this
      _this.loading = true
      _this.$http
        .get(process.env.VUE_APP_URL + 'paperShowList')
        .then(data => {
          if (data.data.code == 200) {
            let examList = data.data.data
            _this.init(examList)
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(err => {
          _this.$message.error('网络错误，请重试')
          console.log(err)
        })
    },
    async init(data) {
      let _this = this
      _this.content = []
      for (var i = 0; i <= data.length; i++) {
        let newResults = await _this.getPaper(data[i].id)
        _this.content = _this.content.concat(newResults)
        _this.content.sort((a, b) => a.code - b.code)
      }
    },
    async getPaper(id) {
      return new Promise((resolve, reject) => {
        let _this = this
        _this.$http
          .get(process.env.VUE_APP_URL + 'paper/penStart/' + id)
          .then(function(data) {
            _this.loading = false
            if (data.data.code != 201) {
              resolve(data.data)
            }
          })
          .catch(function(error) {
            _this.$message.error('网络错误，请刷新界面重试')
            return
          })
      })
    },

    out() {
      this.$router.push({ name: 'Examination' })
    },
    totext(item) {
      if (item.is_verify != 1) {
        this.$router.push({
          name: 'exam_wp',
          params: {
            id: item.id,
          },
        })
        return
      }
      let _this = this
      _this.$http
        .post(process.env.VUE_APP_URL + 'paper/h5/verify', { id: item.id })
        .then(function(data) {
          _this.loading = false
          if (data.data.code == 200) {
            window.location.href = data.data.data.url
          }
        })
        .catch(function(error) {
          _this.$message.error('网络错误，请刷新界面重试')
          return
        })
    },
  },
  mounted() {},
}
</script>

<style scoped>
.all {
  width: 100%;
}
.body {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  height: 100vh;
}
.body-main {
  width: 1200px;
  height: 630px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-body-right {
  text-align: right;
  z-index: 0;
}
.box-card {
  width: 1180px;
  height: 540px;
  border-radius: 20px;
}
.login {
  width: 220px;
  color: #fff;
  height: 50px;
  font-size: 18px;
  font-weight: 600;
  margin: 40px 0 0 255px;
  background: #0672d2;
}
.unfinish {
  background: #aaaaaa;
  /* width: 220px; */
  color: #fff;
  height: 50px;
  font-size: 18px;
  font-weight: 600;
  margin: 40px 0 0 255px;
  padding: 12px 20px;
  border-radius: 4px;
}
.out {
  background: #0672d2;
  width: 220px;
  color: #fff;
  height: 50px;
  font-size: 18px;
  font-weight: 600;
  margin: 40px 255px 0 0;
}
/deep/.el-card__body {
  display: flex;
}
.box-card p {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #6e9fe1;
  font-size: 25px;
  margin-top: 50px;
}
.el-input {
  margin: 10px;
}
/deep/.el-input__inner {
  height: 50px;
  line-height: 50px;
}

i {
  font-size: 18px;
  line-height: 48px;
  color: rgb(59, 60, 62);
  margin: 0 0 0 15px;
  font-family: Microsoft YaHei;
  font-style: normal;
}
.box-radio {
  width: 310px;
  margin: 20px 0;
  padding: 0 20px;
}
.tip {
  margin-top: 20px;
  font-size: 16px;
  color: rgb(110, 110, 110);
  letter-spacing: 1px;
}
/deep/.el-input__inner {
  background-color: rgb(245, 247, 253);
  border: none;
  font-size: 17px;
  color: rgb(59, 60, 62);
}
/deep/.el-input--prefix .el-input__inner {
  padding-left: 115px;
  margin-bottom: 10px;
}
.input {
  width: 140px;
  height: 50px;
  border: inherit;
  background-color: rgb(245, 247, 253);
  padding-left: 75px;
  margin: 0 10px 0 10px;
  border-radius: 4px;
}
.input:disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  font-size: 17px;
  color: #c0c4cc;
  cursor: not-allowed;
  border-radius: 4px;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #4a62e7;
  border-color: #4a62e7;
}
.margin-right {
  margin-right: 130px;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner::after {
  display: none;
}
.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  background-color: rgb(130, 130, 130);
  border: 1px solid #aaaaaa;
}
.footer-tip {
  font-size: 18px;
  text-align: center;
  width: 580px;
  position: relative;
  left: 50%;
  top: 12%;
  letter-spacing: 0.5px;
  color: rgb(130, 130, 130);
  line-height: 30px;
}
.el-divider {
  background-color: #6e9fe1;
}
.divider {
  background-color: rgb(221, 221, 221);
  height: 160px;
  margin-top: 120px;
  position: relative;
  z-index: 1;
}
input[type='text']:focus {
  outline: none;
}
.text-title {
  font-size: 18px;
  position: relative;
  top: -229px;
  left: -395px;
}
.header {
  height: 84px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding-left: 130px;
  padding-bottom: 20px;
  padding-top: 20px;
}
.header p {
  font-size: 27px;
  color: #6e9fe1;
  letter-spacing: 2px;
  margin-left: 5px;
}
.header-img {
  width: 357px;
  height: 84px;
}
.line {
  height: 4em;
}
.el-carousel--horizontal {
  width: 100%;
}
/deep/.el-carousel__container {
  height: 500px;
}
.el-carousel__item {
  padding-left: 45px;
}
.el-icon-warning {
  font-size: 24px;
  color: #0672d2;
}
</style>
